import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HelperService } from './helper.service';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class HttpMonitoringService {

     private static singleton: HttpMonitoringService;
     private _activeConnections: string[] = [];
     private _activeConnections$ = new BehaviorSubject<string[]>(this._activeConnections);
     activeConnections$ = this._activeConnections$.pipe(
          filter(con => !!con),
          map(connections => {
               return connections.length;
          }));

     constructor(
          public helper: HelperService) {
          if (!HttpMonitoringService.singleton) {
               HttpMonitoringService.singleton = this;
          }
     }

     addConnection(url: string) {
          if (!this._activeConnections) {
               this._activeConnections = [];
          }
          this._activeConnections.push(url);
          this._activeConnections$.next(this._activeConnections);
     }

     removeConnection(url: string) {
          const connections = this._activeConnections.filter(con => con !== url);
          this._activeConnections = connections;
          this._activeConnections$.next(this._activeConnections);
     }
}
